import { Layout } from '@components/Mobile';

function DinoGame() {
  return (
    <Layout title="DinoGame">
      <div>dinoGame developing...</div>
    </Layout>
  );
}

export default DinoGame;
